import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import { apiPath, RoutePath } from "../../utility/Constant";
import useFetch from "../../hooks/useFetch";

const ClientUniquePage = () => {
  const { clientsApi } = apiPath;
  const { clients } = RoutePath;
  const navigate = useNavigate();
  let { id } = useParams();
  // data
  const [clientsData] = useFetch(clientsApi);
  // filter with id from data
  const filteredClient = clientsData?.clientsList?.filter(
    (item) => item._id === id
  )[0];

  // Data for form
  const data = [
    {
      elementType: "file",
      label: "Client Image",
      type: "Text",
      defaultValue: filteredClient?.url,
      name: "url",
      required: true,
    },
    {
      elementType: "textField",
      label: "Client Title",
      type: "Text",
      defaultValue: filteredClient?.title,
      name: "title",
      required: false,
    },
  ];

  // handle submit
  const update = (data) => {
    // update data
    const newArray = clientsData?.clientsList.map((item) => {
      if (item._id === id) {
        item.title = data.title;
        item.url = data.url;
        delete item._id;
      }
      return item;
    });
    // set as object
    const newObject = { clientsList: newArray };
    // send api call
    updateData(`${clientsApi}`, newObject, null, null, null, null);
    // send back to clients page
    setTimeout(() => {
      navigate("/" + clients);
    }, 1000);
  };

  return (
    <div>
      {filteredClient?.url && <GlobalForm data={data} update={update} />}
    </div>
  );
};

export default ClientUniquePage;
